import styled from "styled-components";

export const Button = styled.button`
  background-color: ${(props) => props.bgcolor || "#4CAF50"};
  color: ${(props) => props.textcolor || "white"};
  padding: 3px 10px;
  margin: 10px;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.width || "auto"};
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  i {
    margin-right: 8px;
    color: ${(props) => props.textcolor || "white"};
  }
`;
